import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=4326713a&lang=less&scoped=true"

import exportComponent from "/Users/lily/Documents/7pa/qpyx-webs-hongkong-buff-tec/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4326713a"]])

export default __exports__